module.exports = __webpack_public_path__ + "assets_1773901505253/img/pic_5.6228171b.png";